import React from "react";
import {CustomTextField} from "../../../../../components/CustomTextField";
import {InputAdornment} from "@mui/material";
import {CustomPhoneInput} from "../../../../../components/CustomPhoneInput";
import ImageCardGrid from "../../../../../components/ImageCardGrid";
import defaultImage from "../../../../../assets/ImagesDefaults/ic-person.svg";
import {DOCUMENT_ID_MIN_LENGTH} from "../../../../../constant/variable";
import {EmailSubsectionChip, FolderPerson} from "../../../../../components/buttons/IconButtons";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
const VisitorOverview = ({item, disabled, handleChange, emptyFields, isValidPhoneNumber, validatePhone, isValidDocumentId }) => {

    return (
        <div className='row'>
            <div className={"col-sm-12 col-md-2 col-xxl-2 col-lg-2 px-0"}>
                <ImageCardGrid preview={item?.selfie? `data:image/png;base64,${item?.selfie}`: defaultImage} classNameWH={"w-120px h-120px"} />

            </div>
            <div className={"col-sm-12 col-md-10 col-xxl-10 col-lg-10 px-0"}>
                <div className={"row"}>
                    <div className='col-sm-12 col-xxl-12 col-lg-12 mt-2'>
                        <CustomTextField
                            id={'txt_vo_name'}
                            length={32}
                            name={'name'}
                            value={item.name}
                            trans={'name'}
                            type={'text'}
                            disabled={disabled}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                            required={true}
                        />
                    </div>
                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomTextField
                            id={'txt_vo_last_name'}
                            length={32}
                            name={'lastName'}
                            value={item.lastName}
                            trans={'last_name'}
                            type={'text'}
                            disabled={disabled}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                            required={true}
                        />
                    </div>
                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomTextField
                            id={'txt_vo_second_last_name'}
                            length={32}
                            disabled={disabled}
                            name={'secondLastName'}
                            value={item.secondLastName}
                            trans={'second_last_name'}
                            type={'text'}
                            onChange={handleChange}
                            required={false}
                        />
                    </div>
                    <div className='col-12'>
                        <CustomTextField
                            id={'txt_vo_email'}
                            length={64}
                            name={'email'}
                            value={item.email}
                            trans={'email'}
                            type={'text'}
                            emptyFields={emptyFields}
                            required={true}
                            disabled={true}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <EmailSubsectionChip className={'w-h-24px'} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6'>
                        <CustomPhoneInput
                            id='phit_vo_phone_number'
                            value={item.phoneNumber}
                            onChange={(e)=>{
                                const number = e[0] === '+' ? e : `+${e}`;
                                validatePhone(number);
                                handleChange({ target: { value: number, name: 'phoneNumber' } });
                            }}
                            emptyFields={emptyFields}
                            required={true}
                            isValid={isValidPhoneNumber}
                            disabled={disabled}
                        />
                    </div>

                    <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6'>
                        <CustomTextField
                            id={'txt_vo_document_id'}
                            length={DOCUMENT_ID_MIN_LENGTH}
                            name={'documentId'}
                            value={item.documentId}
                            trans={'documentId'}
                            type={'text'}
                            onChange={handleChange}
                            helperText={'document_id_format'}
                            isValid={isValidDocumentId}
                            isValidText={'document_id_format'}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <FolderPerson />
                                    </InputAdornment>
                                ),
                            }}
                            autoComplete={'off'}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VisitorOverview;
